import React from 'react';
import menu from '../../assets/menu.png';
import DropDownComment from './DropDownComment'

export default function CardComment(props) {

  return (
    <div>
      <div className='comment-card'>
        <div className='friend-name-container text-card'>
          <span className='photo-container'>
            <img className='photo-friend-comment' src={props.imgUrl} alt="photo friend" />
          </span>
          <div className='name-comment'>
            <p className='text-name-friend'>{props.name}</p>
            <p className='text-comment'>{props.comment}</p>
          </div>
          <DropDownComment 
            userIdWithComment={props.userIdWithComment} 
            idComment={props.idComment} 
            idUser={props.idUser}
            friendUser={props.friendUser}
            />
        </div>
      </div>
    </div>
  )
}